<p-table
  #dtMainTable
  [scrollable]="true"
  scrollHeight="600px"
  [value]="loadingTable ? skeletonRows : entities"
  [lazy]="true"
  (onLazyLoad)="loadEntities($event)"
  [columns]="selectedColumns"
  dataKey="_id"
  [rows]="itemsByPage"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50, 100]"
  [loading]="loadingTable"
  [paginator]="true"
  [tableStyle]="{'width': '100%'}"
  [(selection)]="selectedEntities"
  [rowHover]="true"
  [totalRecords]="totalRecords"
  currentPageReportTemplate="Mostrando {first} a {last} de {{ totalRecords || 0 }} {{pluralEntityName}}"
  [styleClass]="'p-datatable-sm'"
>
  <ng-template pTemplate="caption">
    <div class="flex flex-row justify-content-between">
      <p-splitButton label="Acciones" [model]="menu" icon="fa-solid fa-gears" styleClass="p-button-outlined p-button-info mr-2 mb-2"></p-splitButton>
      <div>
        <p-multiSelect [options]="columns" [(ngModel)]="selectedColumns" optionLabel="header" selectedItemsLabel="{0} columnas seleccionadas" [style]="{'min-width': '200px'}" placeholder="Escoge las columnas"></p-multiSelect>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th pFrozenColumn></th>
      <ng-container *ngFor="let col of columns">
        <th [style.min-width]="col.width || '15rem'">
          <ng-container *ngIf="col.showFilter">
            <ng-container [ngSwitch]="col.type">
              <ng-container *ngSwitchCase="'numeric'">
                <p-columnFilter type="numeric" [field]="col.field" [currency]="'MXN'"></p-columnFilter>
              </ng-container>
              <ng-container *ngSwitchCase="'number'">
                <p-columnFilter type="numeric" [field]="col.field"></p-columnFilter>
              </ng-container>
              <ng-container *ngSwitchCase="'enum'">
                <div class="flex align-items-center" pSortableColumn="periodType">
                  <p-columnFilter [field]="col.field" matchMode="equals" >
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-dropdown [ngModel]="value" [options]="col.options" (onChange)="filter($event.value)" placeholder="Cualquiera">
                        <ng-template let-option pTemplate="item">
                          <p-tag [value]="option.label" [severity]="option.value | selectEnum: col.enumColor"></p-tag>
                        </ng-template>
                      </p-dropdown>
                    </ng-template>
                  </p-columnFilter>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'boolean'">
                <p-columnFilter type="boolean" [field]="col.field"></p-columnFilter>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <p-columnFilter [type]="col.type" [field]="col.field" [matchMode]="defaultMatchMode(col.type)"></p-columnFilter>
              </ng-container>
            </ng-container>
          </ng-container>
        </th>
      </ng-container>
      <ng-container *ngIf="actions.length > 0">
        <th style="min-width: 5rem"></th>
      </ng-container>
    </tr>
    <tr>
      <th style="padding-left: 15px;" pFrozenColumn>
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <ng-container *ngFor="let col of columns">
        <th [style.min-width]="col.width || '15rem'">
          {{col.header}}
        </th>
      </ng-container>
      <ng-container *ngIf="actions.length > 0">
        <th style="min-width: 5rem"></th>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item let-columns="columns" let-i="rowIndex">
    <!-- Mientras carga, la tabla enseña su propia forma: las columnas que el usuario tiene elegidas,
         con el ancho que corresponde a cada tipo de dato. La superposición de PrimeNG sigue puesta
         —bloquea el clic en el paginador durante la petición—, pero sin su velo ni su rueda: lo que
         se ve es el esqueleto. La opacidad decrece hacia abajo, como en el resto del panel. -->
    <tr *ngIf="loadingTable; else filaReal" [ngClass]="'sk-fade-' + (i > 3 ? 4 : i + 1)" aria-hidden="true">
      <td pFrozenColumn><p-skeleton width="1.2rem" height="1.2rem" borderRadius="4px"></p-skeleton></td>
      <td *ngFor="let col of columns"><p-skeleton height="0.85rem" [width]="skeletonWidth(col)"></p-skeleton></td>
      <td *ngIf="actions.length > 0"><p-skeleton height="1.9rem" width="5.5rem" borderRadius="6px"></p-skeleton></td>
    </tr>

    <ng-template #filaReal>
    <tr>
      <td pFrozenColumn>
        <p-tableCheckbox [value]="item"></p-tableCheckbox>
      </td>
      <td *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.dataType">
          <ng-container *ngSwitchCase="'currency'">
            {{ hasValue(getCellValue(item, col)) ? (getCellValue(item, col) | currency) : '—' }}
          </ng-container>
          <ng-container *ngSwitchCase="'date'">
            {{ hasValue(getCellValue(item, col)) ? (getCellValue(item, col) | date: 'dd-MM-YYYY': '-0600') : '—' }}
          </ng-container>
          <ng-container *ngSwitchCase="'timeElapsed'">
            {{ hasValue(getCellValue(item, col)) ? (getCellValue(item, col) | timeElapsed) : '—' }}
          </ng-container>
          <ng-container *ngSwitchCase="'link'">
            <a class="link-subsection" routerLink="{{'/'+col.rootLink+'/'+getValueObject(item, col.linkField)}}">{{getCellValue(item, col)}}</a>
          </ng-container>
          <ng-container *ngSwitchCase="'progress'">
            <p-progressBar [style]="{ height: '12px', fontSize: '12px' }" [value]="roundNumber(getCellValue(item, col))"></p-progressBar>
          </ng-container>
          <ng-container *ngSwitchCase="'enum'">
            <!-- Guard por 'N/A'/'' (sentinel de getValueObject para campos ausentes), NO por
                 truthiness: un enum booleano con valor `false` es válido y debe pintar su badge
                 (p.ej. hasActiveLease=false → "Sin arrendamiento activo"). -->
            <ng-container *ngIf="getCellValue(item, col) !== 'N/A' && getCellValue(item, col) !== ''; else elseEnum ">
              <p-tag [value]="getCellValue(item, col) | selectEnum:col.enum" [severity]="getCellValue(item, col) | selectEnum:col.enumColor"></p-tag>
            </ng-container>
            <ng-template #elseEnum>
              --
            </ng-template>
          </ng-container>
          <!-- Se compara contra `true`, no por truthiness: cuando el campo no existe en el documento
               (registros anteriores a que se agregara la bandera) getValueObject devuelve el string
               'N/A', que es truthy y pintaba una palomita verde para quien NO lo tiene. -->
          <ng-container *ngSwitchCase="'boolean'">
            <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': getCellValue(item, col) === true, 'text-red-500 pi-times-circle': getCellValue(item, col) !== true }"></i>
          </ng-container>
          <ng-container *ngSwitchCase="'channel'">
            <ng-container *ngIf="getCellValue(item, col) as ch">
              <span class="channel-cell-pill" *ngIf="ch !== 'N/A'; else elseChannel">{{ ch | channelLabel }}</span>
            </ng-container>
            <ng-template #elseChannel>--</ng-template>
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{getCellValue(item, col)}}
          </ng-container>
        </ng-container>
      </td>
      <!--
        La columna de acciones va AL FINAL y se desplaza con la tabla, no pegada al borde.
        Se probó fijarla (`pFrozenColumn alignFrozen="right"`) y se revirtió: en pantallas angostas
        la columna congelada se queda encima del contenido y tapa las demás, así que en móvil no se
        ve más que los botones. Una tabla ancha se resuelve arrastrando; una columna que tapa el dato
        no se resuelve de ninguna forma.
      -->
      <ng-container *ngIf="actions.length > 0">
        <td>
          <div class="table-row-actions">
            <ng-container *ngFor="let action of actions">
              <ng-container *ngIf="showAction(item, action.rule)">
                <button
                  pButton
                  class="p-button p-button-sm p-button-{{action.color}}"
                  [label]="action.title"
                  [icon]="action.icon"
                  *appIfHasPermission="action.permission"
                  (click)="onAction.emit({event: $event, action: action.action, data: item})"
                ></button>
              </ng-container>
            </ng-container>
          </div>
        </td>
      </ng-container>
    </tr>
    </ng-template>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <!-- El colspan se calcula: columnas elegidas + la casilla de selección + la de acciones si
           las hay. Estaba fijo en 7 y en casi todas las tablas el mensaje no abarcaba la fila. -->
      <td [attr.colspan]="selectedColumns.length + (actions.length > 0 ? 2 : 1)">No se encontraron {{pluralEntityName}}</td>
    </tr>
  </ng-template>
</p-table>
<p-toast></p-toast>
